import { signal } from "@preact/signals-react"
import { useEffect } from "react"

import { addNotification } from "../stores/notification-store"
import { fetchDeviceForms, fetchDeviceSchemas } from "../utils/api"

export const deviceFormsSignal = signal([])
export const deviceSchemasSignal = signal([])
export const errorSignal = signal(null)
export const loadingSignal = signal(false)
export const modifiedSignal = signal(false) // allows a component to flag the data as modified so subsequent calls to the hook will reload it
export const parameterHash = signal(null)

const fetchData = async (businessEntityId, config, accessToken) => {
	let print = false
	const hash = await import('object-hash').then(module => module.default || module)
	// if any parameters have changed then flag as modified so that the hook will reload the data
	const currentParametersHash = hash([businessEntityId, config, accessToken])
	if (currentParametersHash != parameterHash.value) {
		modifiedSignal.value = true
		parameterHash.value = currentParametersHash
	}

	// short-circuit if we have a pending request, are waiting for parameters or have already received an error
	if (loadingSignal.value || !businessEntityId || !config || !accessToken || errorSignal.value || !modifiedSignal.value) {
		return
	}
	try {
		loadingSignal.value = true
		deviceSchemasSignal.value = await fetchDeviceSchemas(config, accessToken)
		deviceFormsSignal.value = await fetchDeviceForms(businessEntityId, config, accessToken)
		if (print) {
			console.log("Got the following device forms:")
			console.log(deviceFormsSignal.value)
		}
	}
	catch (err) {
		errorSignal.value = err
		console.log(err)
		addNotification(`Unable to load form data due to the following error - ${err}`)
	}
	finally {
		loadingSignal.value = false
		modifiedSignal.value = false
	}
}

export default function useDeviceForms(businessEntityId, config, accessToken) {
	useEffect(() => {
		fetchData(businessEntityId, config, accessToken)
	}, [businessEntityId, config, accessToken])

	return {
		deviceFormsSignal, deviceSchemasSignal, loadingSignal, errorSignal, modifiedSignal
	}
}